module.exports = __webpack_public_path__ + "img/bottom-cta-button@2x.32578cb7.png";